import { Injectable, Signal, signal } from '@angular/core'
import { UserRolesEnum } from '@ui-core/enums/user-roles.enum'
import { UserInterface } from '@ui-core/interfaces/user.interface'

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private _logoDark = signal<string | null>(null)
    private _logoLight = signal<string | null>(null)
    private _logout = signal<boolean>(false)
    private _roles = signal<string[]>([])
    private _user = signal<UserInterface | null>(null)

    public get(): Signal<UserInterface | null> {
        return this._user
    }

    public get roles(): Signal<string[]> {
        return this._roles
    }

    public set(value: UserInterface | null): void {
        this._user.set(value)
    }

    public setRoles(value: string[]): void {
        const mappedRoles = value.filter((role: string) => Object.values(UserRolesEnum).includes(role as UserRolesEnum))
        this._roles.set(mappedRoles)
    }

    public hasRoles(roles: string[]): boolean {
        let result = true

        for (const role of roles) {
            result = this.roles().includes(role)
            if (!result) {
                break
            }
        }

        return result
    }

    public hasAnyRole(roles: string[]): boolean {
        let result = false

        for (const role of roles) {
            result = this.roles().includes(role)

            if (result) {
                break
            }
        }

        return result
    }

    public setLogoLight(value: string | null): void {
        this._logoLight.set(value)
    }

    public logoLight(): Signal<string | null> {
        return this._logoLight
    }

    public setLogoDark(value: string | null): void {
        this._logoDark.set(value)
    }

    public logoDark(): Signal<string | null> {
        return this._logoDark
    }

    public setLogout(value: boolean): void {
        this._logout.set(value)
    }

    public isLogout(): Signal<boolean> {
        return this._logout
    }
}
